
export const topMenuLinks = [
    {
      path: "/profile/",
      name: "Profile",
      reqLogin: true
    },
    {
      path: "/settings/",
      name: "Settings",
      reqLogin: true
    },
    {
      path: "/contact/",
      name: "Contact",
      reqLogin: false
    },
    {
      path: "/logout/",
      name: "Log out",
      reqLogin: true
    }
];